module.exports = function interweaveOtherEvents(events, otherEvents) {
    for (var i = 0; i < otherEvents.length; i++) {
        let inserted = tryInsert(events, otherEvents[i]);
        if(!inserted)
            events.push(otherEvents[i]);
    }

	function tryInsert(events, otherEvent) {
	    for (var j = 0; j < events.length; j++) {
	        var candidate = events[j].ticks;
	        if(otherEvent.ticks < candidate){
	            events.splice(j, 0, otherEvent);
	            return true;
	        }
	    }
	    return false;
	}
};